(function() {
  const CART_KEY = 'vw_cart_open';
  const CART_SELECTOR = '[data-component="global/slide-cart-trigger"], [aria-controls="slide-cart"], a[href="/cart"]';

  function checkCartStatus() {
    const url = new URL(window.location.href);
    if (url.searchParams.has(CART_KEY)) {
     
      setTimeout(() => {
        const cartBtn = document.querySelector(CART_SELECTOR);
        
        if (cartBtn) {
          cartBtn.click();
          url.searchParams.delete(CART_KEY);
          window.history.replaceState(null, '', url.toString());
        } else {
     
          const drawer = document.querySelector('#slide-cart');
          if(drawer) {
              drawer.classList.remove('invisible');
              drawer.setAttribute('aria-modal', 'true');
          }
        }
      }, 1200); 
    }
  }

  window.addEventListener('videowiseProductAddToCart', () => {
    const url = new URL(window.location.href);
    url.searchParams.set(CART_KEY, 'true');
    window.location.href = url.toString();
  }, false);

  function getCleanHandle() {
    const path = window.location.pathname;
    if (!path.includes('/products/')) return null;
    
    const parts = path.split('/products/');
    if (parts.length > 1) {
      return parts[1].split('/')[0].split('?')[0].split('#')[0];
    }
    return null;
  }

  function updateVideowiseForProduct() {
    const handle = getCleanHandle();
    if (!handle) return;

    fetch(`/products/${handle}.json`)
      .then(res => res.json())
      .then(data => {
        if (data.product && window.__st) {
          window.__st.rid = data.product.id;
          if (window.videowiseInfo) window.videowiseInfo.pid = data.product.id;
          
          if (typeof window.videowiseBulkTrigger === "function") {
            window.videowiseIdsLoaded = [];
            setTimeout(() => window.videowiseBulkTrigger(), 500);
          }
        }
      }).catch(err => console.error('Error updating Videowise:', err));
  }

  const originalPushState = history.pushState;
  history.pushState = function() {
    originalPushState.apply(history, arguments);
    updateVideowiseForProduct();
  };

  window.addEventListener('popstate', updateVideowiseForProduct);
  
  checkCartStatus();
  updateVideowiseForProduct();

})();